module.exports = __webpack_public_path__ + "img/AlmedinaSelmani.d6ac23dd.png";